import { apiHandlerWithError } from 'api';

export default async function putCalendarItemTags(calendarItemId, tagIds) {
  return await apiHandlerWithError.put(`calendar-items/${calendarItemId}/tags`, tagIds);
}
